import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { chatUnseenCountsAtom } from '../states/chatAtoms';
import eventBus from '../utils/eventBus';

const ChatUnreadManager = () => {
    const [unseenCounts, setUnseenCounts] = useAtom(chatUnseenCountsAtom);

    useEffect(() => {
        const handleUnseenMessage = (data) => {
            const conversationId = data.conversation_id;
            if (!conversationId) return;

            setUnseenCounts((prev) => ({
                ...prev,
                [conversationId]: (prev[conversationId] || 0) + 1,
            }));
        };

        eventBus.on('NEW_MESSAGE', handleUnseenMessage);

        return () => {
            eventBus.off('NEW_MESSAGE', handleUnseenMessage);
        };
    }, [setUnseenCounts]);

    return null;
};

export default ChatUnreadManager;